// Projection d'affichage uniquement : le serveur reste l'autorité d'écriture.
export function accesBoutiquePublic(campagne = {}, publication, { ferme = false, pasEncoreOuverte = false, apercuAdministrateur = false } = {}) {
  // La présentation publique reste strictement non commandable. L'aperçu
  // administrateur local doit cependant pouvoir parcourir le tunnel complet ;
  // la création finale est bloquée séparément par le mode simulation.
  const presentation = !apercuAdministrateur && (campagne.presentation_publique === true || publication?.presentation_publique === true);
  // Compatibilité des aperçus historiques sans projection ; une projection reçue
  // mais incomplète est refusée plutôt qu'interprétée comme une autorisation.
  const serveurAutorise = publication == null || publication.commandes_ouvertes === true;
  return {
    presentation,
    commandeAutorisee: !presentation && !ferme && !pasEncoreOuverte && (apercuAdministrateur || serveurAutorise),
    ajoutAutorise: !presentation && !ferme && (apercuAdministrateur || (!pasEncoreOuverte && serveurAutorise)),
  };
}
